module.exports = __webpack_public_path__ + "img/08.90c08190.jpg";